import {createFeatureSelector, createSelector} from '@ngrx/store';
import {cyberSourceInitialState, CyberSourcePaymentState, PAYMENT_AUTHORIZATION_FEATURE} from '../payment-state';
import {CyberSourceActions, CyberSourceActionTypes} from '@app/payment/services/store/actions/cyber-source.action';

const getCyberSourceFeatureState = createFeatureSelector<{
  cyberSource: CyberSourcePaymentState;
}>(PAYMENT_AUTHORIZATION_FEATURE);

export const getState = createSelector(getCyberSourceFeatureState, (state) => state.cyberSource);

export const cyberSourceReducer = (
  state = cyberSourceInitialState,
  action: CyberSourceActions
): CyberSourcePaymentState => {
  switch (action.type) {
    case CyberSourceActionTypes.StartPaymentFlow:
      return {
        data: undefined,
        error: false,
        authEnrollmentResponse: undefined,
      };
    case CyberSourceActionTypes.Invoke3ds:
      return {
        ...state,
        authEnrollmentResponse: action.payerAuthEnrollmentResponse,
      };
    case CyberSourceActionTypes.ChallengeFailure:
      return {
        ...state,
        error: true,
      };
    case CyberSourceActionTypes.PaymentSuccess:
      return {
        ...state,
        error: false,
        data: action.data,
      };
    case CyberSourceActionTypes.PaymentFailure:
      return {
        ...state,
        error: true,
      };
    case CyberSourceActionTypes.GenericError:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};
